// extracted by mini-css-extract-plugin
export default {"readonlyComment":"RichTextReadOnlyComment_readonlyComment__4V7gc"};